module.exports = __webpack_public_path__ + "static/media/bgvideo.b618bb98.mp4";